import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { SearchResultModel } from '@sb-tools/typescript/models/search-result.model';
import { FieldSearchModel } from '@sb-tools/typescript/models/field-search.model';
import { SimpleMessageDTO } from '@sb-tools/typescript/models/dto/simple-message.dto';

@Injectable({
    providedIn: 'root',
})
export class SearchTicketsService {
    constructor(private httpClient: HttpClient) {}

    get(searchParams): Observable<SearchResultModel<any>> {
        return this.httpClient.post<SearchResultModel<any>>(
            environment.apiInboxUrl + 'search/tickets/results/v2?ticketId=null',
            searchParams,
        );
    }

    getUserPreviousMessages(authorId: string): Observable<SimpleMessageDTO[]> {
        return this.httpClient.get<SimpleMessageDTO[]>(environment.apiInboxUrl + 'user/' + authorId + '/lastTickets/');
    }

    getAvailableTicketSubTypes(): Observable<any> {
        return this.httpClient.get<any>(environment.apiInboxUrl + 'search/tickets/AvailableTicketSubTypes/');
    }

    getAvailableFields(): Observable<FieldSearchModel[]> {
        return this.httpClient.get<FieldSearchModel[]>(environment.apiInboxUrl + 'search/fields/');
    }
}
